// removed by extract-text-webpack-plugin
module.exports = {"root":"BookingTimeInfo__root__1sj4T","bookingInfo":"BookingTimeInfo__bookingInfo__3vUYt","dateSection":"BookingTimeInfo__dateSection__2F_-W","dateLabel":"BookingTimeInfo__dateLabel__13jYu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BookingTimeInfo/BookingTimeInfo.css
// module id = 1521
// module chunks = 0